import { useSelector } from 'react-redux';

import { SearchStatus } from '../../../constants';
import HomeAgent from '../Agent';
import HomeCustomerPage from './HomeCustomerPage';

const HomeCustomer = () => {
  const { searchStatus, isResetSearchResult } = useSelector((state) => state.tripSearch);
  const { deepLinkSearchStatus } = useSelector((store) => store.hotel);
  // When user change search mode on results page we dispatch resetSearchResults.
  // In case mode change show HomeAgent. Without isResetSearchResult,
  // it will not allow to change search mode on results page
  return (searchStatus || deepLinkSearchStatus)
  !== SearchStatus.INITIAL || isResetSearchResult
    ? <HomeAgent /> : <HomeCustomerPage />;
};
export default HomeCustomer;
